import springCenfApi from '../../services/springCenfApi'

export const updateSupplier = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/suppliers/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)